export enum MODAL_SIZES {
	Small = 'sm',
	Medium = 'md',
	Large = 'lg',
	XLarge = 'xlg',
	XXLarge = 'xxlg'
}
